import { render, staticRenderFns } from "./HelpCenterPanel.vue?vue&type=template&id=0841fba6&scoped=true&"
import script from "./HelpCenterPanel.vue?vue&type=script&lang=js&"
export * from "./HelpCenterPanel.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterPanel.vue?vue&type=style&index=0&id=0841fba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841fba6",
  null
  
)

export default component.exports